const SectionLabel = ({ children, className = '' }) => {
  return (
    <span className={`text-[11px] tracking-[0.3em] uppercase ${className}`} style={{ fontFamily: "'DM Mono', monospace", color: '#C25E3E' }}>
      {children}
    </span>
  );
};

export default SectionLabel;
